module.exports = __webpack_public_path__ + "media/promo-video.c06a253.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promo-video.mp4
// module id = 1226
// module chunks = 1